export class StateMachine {
    constructor(owner, initialState = null) {
        this.owner = owner;
        this.currentState = null;
        this.states = new Map();
        this.globalState = null;
        this.previousState = null;
        
        if (initialState) {
            this.currentState = initialState;
        }
    }

    // Add a state to the state machine
    addState(stateName, stateInstance) {
        this.states.set(stateName, stateInstance);
        stateInstance.stateMachine = this;
        stateInstance.owner = this.owner;
    }

    // Change to a new state
    changeState(newStateName) {
        if (!this.states.has(newStateName)) {
            console.warn(`State '${newStateName}' not found in state machine`);
            return;
        }

        // Exit current state
        if (this.currentState) {
            this.currentState.exit();
            this.previousState = this.currentState;
        }

        // Enter new state
        this.currentState = this.states.get(newStateName);
        
        // Debug for jump zombies
        if (this.owner.mobType === 'jump_zombie') {
        }
        
        this.currentState.enter();
    }

    // Update the current state
    update(deltaTime) {
        if (this.globalState) {
            this.globalState.update(deltaTime);
        }

        if (this.currentState) {
            this.currentState.update(deltaTime);
        }
    }

    // Handle messages/events
    handleMessage(message) {
        if (this.currentState && this.currentState.onMessage) {
            if (this.currentState.onMessage(message)) {
                return true;
            }
        }

        if (this.globalState && this.globalState.onMessage) {
            return this.globalState.onMessage(message);
        }

        return false;
    }

    // Revert to previous state
    revertToPreviousState() {
        if (this.previousState) {
            this.changeState(this.previousState.constructor.name);
        }
    }

    // Get current state name
    getCurrentStateName() {
        return this.currentState ? this.currentState.constructor.name : 'None';
    }

    // Check if in specific state
    isInState(stateName) {
        return this.currentState && this.currentState.constructor.name === stateName;
    }
}

// Base State class that all states should inherit from
export class State {
    constructor() {
        this.stateMachine = null;
        this.owner = null;
    }

    // Called when entering this state
    enter() {
        // Override in subclasses
    }

    // Called every frame while in this state
    update(deltaTime) {
        // Override in subclasses
    }

    // Called when exiting this state
    exit() {
        // Override in subclasses
    }

    // Handle messages/events
    onMessage(message) {
        // Override in subclasses
        return false;
    }
} 